export {default as schemeAccent} from "./src/categorical/Accent";
export {default as schemeDark2} from "./src/categorical/Dark2";
export {default as schemePaired} from "./src/categorical/Paired";
export {default as schemePastel1} from "./src/categorical/Pastel1";
export {default as schemePastel2} from "./src/categorical/Pastel2";
export {default as schemeSet1} from "./src/categorical/Set1";
export {default as schemeSet2} from "./src/categorical/Set2";
export {default as schemeSet3} from "./src/categorical/Set3";
export {default as interpolateBrBG, scheme as schemeBrBG} from "./src/diverging/BrBG";
export {default as interpolatePRGn, scheme as schemePRGn} from "./src/diverging/PRGn";
export {default as interpolatePiYG, scheme as schemePiYG} from "./src/diverging/PiYG";
export {default as interpolatePuOr, scheme as schemePuOr} from "./src/diverging/PuOr";
export {default as interpolateRdBu, scheme as schemeRdBu} from "./src/diverging/RdBu";
export {default as interpolateRdGy, scheme as schemeRdGy} from "./src/diverging/RdGy";
export {default as interpolateRdYlBu, scheme as schemeRdYlBu} from "./src/diverging/RdYlBu";
export {default as interpolateRdYlGn, scheme as schemeRdYlGn} from "./src/diverging/RdYlGn";
export {default as interpolateSpectral, scheme as schemeSpectral} from "./src/diverging/Spectral";
export {default as interpolateBuGn, scheme as schemeBuGn} from "./src/sequential-multi/BuGn";
export {default as interpolateBuPu, scheme as schemeBuPu} from "./src/sequential-multi/BuPu";
export {default as interpolateGnBu, scheme as schemeGnBu} from "./src/sequential-multi/GnBu";
export {default as interpolateOrRd, scheme as schemeOrRd} from "./src/sequential-multi/OrRd";
export {default as interpolatePuBuGn, scheme as schemePuBuGn} from "./src/sequential-multi/PuBuGn";
export {default as interpolatePuBu, scheme as schemePuBu} from "./src/sequential-multi/PuBu";
export {default as interpolatePuRd, scheme as schemePuRd} from "./src/sequential-multi/PuRd";
export {default as interpolateRdPu, scheme as schemeRdPu} from "./src/sequential-multi/RdPu";
export {default as interpolateYlGnBu, scheme as schemeYlGnBu} from "./src/sequential-multi/YlGnBu";
export {default as interpolateYlGn, scheme as schemeYlGn} from "./src/sequential-multi/YlGn";
export {default as interpolateYlOrBr, scheme as schemeYlOrBr} from "./src/sequential-multi/YlOrBr";
export {default as interpolateYlOrRd, scheme as schemeYlOrRd} from "./src/sequential-multi/YlOrRd";
export {default as interpolateBlues, scheme as schemeBlues} from "./src/sequential-single/Blues";
export {default as interpolateGreens, scheme as schemeGreens} from "./src/sequential-single/Greens";
export {default as interpolateGreys, scheme as schemeGreys} from "./src/sequential-single/Greys";
export {default as interpolatePurples, scheme as schemePurples} from "./src/sequential-single/Purples";
export {default as interpolateReds, scheme as schemeReds} from "./src/sequential-single/Reds";
export {default as interpolateOranges, scheme as schemeOranges} from "./src/sequential-single/Oranges";



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/index.js
// module id = 181
// module chunks = 0